import * as preferencesSelectors from 'companion-app-components/flux/preferences/selectors';

import store from 'store';
import { createSelector } from 'reselect';
import { getThemeByKey } from 'themes/themeBase';

type ThemeKey = 'light' | 'dark';

const DEFAULT_THEME: ThemeKey = 'light';

const getStoredThemeKey = (): ThemeKey | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const themeKey = window.localStorage?.getItem('theme');
  return themeKey === 'dark' || themeKey === DEFAULT_THEME ? themeKey : null;
};

const getDatasetThemeKey = (state: any): string | undefined => (
  preferencesSelectors.getSharedPreferencesByPath(state, { group: 'user', path: ['webApp'] }) || {}
).theme;

const getPreferencesLoadingState = (state: any): any => preferencesSelectors.getLoadPendingState(state);

export const getCurrentThemeKey = createSelector(
  getDatasetThemeKey,
  getPreferencesLoadingState,
  (themeKey, preferencesLoading) => {
    if (themeKey) {
      return themeKey;
    }

    if (preferencesLoading?.shared?.dataset) {
      return getStoredThemeKey() || DEFAULT_THEME;
    }

    return DEFAULT_THEME;
  },
);

export const getCurrentTheme = createSelector(
  getCurrentThemeKey,
  (themeKey) => getThemeByKey(themeKey),
);

// don't use this method, unless you know what you are doing
export const dangerouslyGetTheme = () => {
  const state = store.getState();
  const themeKey = state ? getCurrentThemeKey(state) : DEFAULT_THEME;
  return getThemeByKey(themeKey);
};
